import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { hasUserInput } from '@gift-variable-plugins/photo-shared/hasUserInput';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';

export const getPhotoStatus = (
    input: GiftJson.Input<PhotoVariableInput>
): 'error' | 'pending' | 'ready' => {
    if (!hasUserInput(input.value)) {
        return 'ready';
    } else if (input.value.status === 'error') {
        return 'error';
    } else if (input.value.status === 'saving') {
        return 'pending';
    } else {
        return 'ready';
    }
};